export const dsgTranslation = {
  en: {
    home: "Home",
    settings: "Settings",
    dsgSettings: "DSG Settings",
    systemControls: "System Controls",
    isLtvCertificateEnabled: "Is LTV certificate Enabled",
    configurationSettings: "Configuration Settings",
    tsiType: "TSI Type",
    clientCode: "Client Code",
    clientSecret: "Client Secret",
    clientId: "Client ID",
    redirectUrl: "Redirect URL",
    dsgLink: "DSG Link",
    tsiStandard: "TSI Standard",
    standardNumber: " ETSI Standard Number",
    containerType: "Container Type",
    signatureFormat: "Signature Format",
    signaturePackage: "Signature Packaging",
    signatureOptionSign: "Signature Option Sign",
    signatureLevel: "Signature Level",
    signatureDigestAlgorithm: "Signature Digest Algorithm",
    signatureTokenApi: "Signature Token API",
    updateSettings: "Update Settings",
  },
  ar: {
    home: "الصفحة الرئيسية",
    settings: "الإعدادات",
    dsgSettings: "إعدادات DSG",
    systemControls: "ضوابط النظام",
    isLtvCertificateEnabled: "هل شهادة LTV مفعلة",
    configurationSettings: "إعدادات التكوين",
    tsiType: "نوع TSI",
    clientCode: "رمز العميل",
    clientSecret: "سر العميل",
    clientId: "معرف العميل",
    redirectUrl: "عنوان URL لإعادة التوجيه",
    dsgLink: "رابط DSG",
    tsiStandard: "معيار TSI",
    standardNumber: "رقم معيار ETSI",
    containerType: "نوع الحاوية",
    signatureFormat: "تنسيق التوقيع",
    signaturePackage: "تغليف التوقيع",
    signatureOptionSign: "خيار توقيع التوقيع",
    signatureLevel: "مستوى التوقيع",
    signatureDigestAlgorithm: "خوارزمية تجزئة التوقيع",
    signatureTokenApi: "واجهة برمجة تطبيقات رمز التوقيع",
    updateSettings: "تحديث الإعدادات",
  },
};
